/**
 * Thin client for battleship_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'battleship';

export const BATTLESHIP_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.battleship?.API_BASE || '')
    : '/battleship';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Battleship GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createBattleshipSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${BATTLESHIP_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveBattleshipSession(sessionId, { row, col } = {}) {
    const res = await fetch(`${BATTLESHIP_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ row, col }),
    });
    return parseJson(res);
}

export async function deleteBattleshipSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${BATTLESHIP_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const HIT_POINTS = 50;
export const SINK_BONUS = 80;
export const FLEET_CLEAR_BONUS = 250;

export const computeBattleshipScore = (hits, shipsSunk, fleetCleared = false) => {
    let score = hits * HIT_POINTS + shipsSunk * SINK_BONUS;
    if (fleetCleared) score += FLEET_CLEAR_BONUS;
    return score;
};
